/* Egen markør og magnetiske knapper. Bare på enheter med mus, og bare når
   brukeren ikke har bedt om redusert bevegelse. Markøren er dekorativ:
   nettleserens egen peker skjules ikke, slik at ingenting går tapt om
   skriptet feiler. */

import gsap from 'gsap';
import { $, $$, finPeker, mindreBevegelse } from './verktoy.js';

export function startMarkor() {
  if (!finPeker.matches || mindreBevegelse.matches) return;

  const ring = $('.markor');
  const punkt = $('.markor-punkt');
  const merkelapp = ring.querySelector('span');

  const rx = gsap.quickTo(ring, 'x', { duration: .45, ease: 'power3' });
  const ry = gsap.quickTo(ring, 'y', { duration: .45, ease: 'power3' });
  const px = gsap.quickTo(punkt, 'x', { duration: .08 });
  const py = gsap.quickTo(punkt, 'y', { duration: .08 });

  let vist = false;
  addEventListener('pointermove', e => {
    if (!vist) {
      // Første bevegelse: plasser markøren før den vises, ellers glir den
      // inn fra hjørnet.
      vist = true;
      gsap.set([ring, punkt], { x: e.clientX, y: e.clientY });
      document.body.classList.add('markor-synlig');
    }
    rx(e.clientX); ry(e.clientY);
    px(e.clientX); py(e.clientY);
  }, { passive: true });

  for (const el of $$('a, button')) {
    el.addEventListener('mouseenter', () => ring.classList.add('over'));
    el.addEventListener('mouseleave', () => ring.classList.remove('over'));
  }

  /* Elementer med data-markor bytter markøren til en merket sirkel. */
  for (const el of $$('[data-markor]')) {
    el.addEventListener('mouseenter', () => {
      merkelapp.textContent = el.dataset.markor;
      ring.classList.add('merket');
    });
    el.addEventListener('mouseleave', () => ring.classList.remove('merket'));
  }

  /* Magnetiske knapper: elementet trekkes litt mot pekeren. */
  for (const el of $$('[data-magnet]')) {
    const mx = gsap.quickTo(el, 'x', { duration: .6, ease: 'elastic.out(1,.4)' });
    const my = gsap.quickTo(el, 'y', { duration: .6, ease: 'elastic.out(1,.4)' });
    el.addEventListener('pointermove', e => {
      const r = el.getBoundingClientRect();
      mx((e.clientX - r.left - r.width / 2) * .3);
      my((e.clientY - r.top - r.height / 2) * .4);
    });
    el.addEventListener('pointerleave', () => { mx(0); my(0); });
  }
}
